// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #1351F1;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-modal-overlay {
  position: fixed;
  z-index: 9;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.fk-modal-overlay .fk-modal {
  background-color: #ffffff;
  border: 1px solid #bebebe;
  border-radius: 2px;
  padding: 12px 16px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
  min-width: 400px;
  max-width: 700px;
  position: relative;
}
.fk-modal-overlay .fk-modal .fk-modal-close {
  position: absolute;
  right: 10px;
  transition: transform 0.5s ease-in-out;
  font: normal normal bold 22px/27px "Noto Sans";
}
.fk-modal-overlay .fk-modal .fk-modal-close:hover {
  cursor: pointer;
  opacity: 0.8;
  transform: rotate(360deg);
}
.fk-modal-overlay .fk-modal .fk-modal-title {
  font: normal normal bold 20px/27px "Noto Sans";
  text-align: center;
  margin-top: 30px;
}
.fk-modal-overlay .fk-modal .fk-modal-body {
  padding: 30px 120px;
  font: normal normal normal 16px/24px "Noto Sans";
  text-align: center;
}
.fk-modal-overlay .fk-modal .fk-modal-body.bold {
  font: normal normal bold 20px/27px "Noto Sans";
}
.fk-modal-overlay .fk-modal .fk-modal-body.--close-complain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 80px;
}
.fk-modal-overlay .fk-modal .fk-modal-body.--close-complain hr {
  width: 100%;
}
.fk-modal-overlay .fk-modal .fk-modal-body.--close-complain .comment-description {
  display: block;
  width: 85%;
  font: normal normal normal 14px/17px "Dosis";
  color: #434343;
}
.fk-modal-overlay .fk-modal .fk-modal-body.--close-complain .fk-input--with-counter {
  width: 100%;
  margin: 20px 0 0 0;
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain {
  display: flex;
  flex-direction: row;
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain .close-result-button {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain .close-result-button img {
  width: 60px;
  filter: grayscale(100%);
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain .close-result-button img:hover {
  filter: none;
  cursor: pointer;
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain .close-result-button img.selected {
  filter: none;
}
.fk-modal-overlay .fk-modal .fk-modal-body .--close-complain .close-result-button span {
  width: 75%;
  margin-top: 15px;
  font: normal normal normal 14px/17px "Dosis";
  color: #434343;
}
.fk-modal-overlay .fk-modal .fk-modal-buttons {
  display: flex;
  gap: 20px;
  padding: 10px 140px 50px 140px;
}
.fk-modal-overlay .fk-modal .fk-modal-buttons button {
  color: #FFFFFF;
  padding: 15px 30px;
}
.fk-modal-overlay .fk-modal .fk-modal-buttons button:disabled {
  opacity: 0.7;
}
.fk-modal-overlay .fk-modal .fk-modal-buttons .fk-modal-button-normal {
  background: #1351F1;
}
.fk-modal-overlay .fk-modal .fk-modal-buttons .fk-modal-button-danger {
  background: #F8A01E;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/modal/modal.styles.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACI,eAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAgCJ;AA9BI;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAgCR;AA9BQ;EACI,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,8CAAA;AAgCZ;AA9BY;EACI,eAAA;EACA,YAAA;EACA,yBAAA;AAgChB;AA5BQ;EACI,8CAAA;EACA,kBAAA;EACA,gBAAA;AA8BZ;AA3BQ;EACI,mBAAA;EACA,gDAAA;EACA,kBAAA;AA6BZ;AA3BY;EACI,8CAAA;AA6BhB;AA1BY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA4BhB;AA1BgB;EACI,WAAA;AA4BpB;AAzBgB;EACI,cAAA;EACA,UAAA;EACA,4CAAA;EACA,cAAA;AA2BpB;AAxBgB;EACI,WAAA;EACA,kBAAA;AA0BpB;AAtBY;EACI,aAAA;EACA,mBAAA;AAwBhB;AAtBgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAwBpB;AAtBoB;EACI,WAAA;EACA,uBAAA;AAwBxB;AAtBwB;EACI,YAAA;EACA,eAAA;AAwB5B;AArBwB;EACI,YAAA;AAuB5B;AAnBoB;EACI,UAAA;EACA,gBAAA;EACA,4CAAA;EACA,cAAA;AAqBxB;AAfQ;EACI,aAAA;EACA,SAAA;EACA,8BAAA;AAiBZ;AAfY;EACI,cAAA;EACA,kBAAA;AAiBhB;AAfgB;EACI,YAAA;AAiBpB;AAbY;EACI,mBDrHA;ACoIhB;AAZY;EACI,mBDxHG;ACsInB","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #1351F1;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000; // #ff1744\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.fk-modal-overlay {\n    position: fixed;\n    z-index: 9;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .fk-modal {\n        background-color: #ffffff;\n        border: 1px solid #bebebe;\n        border-radius: 2px;\n        padding: 12px 16px;\n        box-shadow: 0px 3px 6px #00000029;\n        border-radius: 10px;\n        min-width: 400px;\n        max-width: 700px;\n        position: relative;\n\n        .fk-modal-close {\n            position: absolute;\n            right: 10px;\n            transition: transform .5s ease-in-out;\n            font: normal normal bold 22px/27px $main-font;\n\n            &:hover {\n                cursor: pointer;\n                opacity: .8;\n                transform: rotate(360deg);\n            }\n        }\n\n        .fk-modal-title {\n            font: normal normal bold 20px/27px $main-font;\n            text-align: center;\n            margin-top: 30px;\n        }\n\n        .fk-modal-body {\n            padding: 30px 120px;\n            font: normal normal normal 16px/24px $main-font;\n            text-align: center;\n\n            &.bold {\n                font: normal normal bold 20px/27px $main-font;\n            }\n\n            &.--close-complain {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n                padding: 30px 80px;\n\n                hr {\n                    width: 100%;\n                }\n\n                .comment-description {\n                    display: block;\n                    width: 85%;\n                    font: normal normal normal 14px/17px $fourth-font;\n                    color: #434343;\n                }\n\n                .fk-input--with-counter {\n                    width: 100%;\n                    margin: 20px 0 0 0;\n                }\n            }\n\n            .--close-complain {\n                display: flex;\n                flex-direction: row;\n\n                .close-result-button {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n\n                    img {\n                        width: 60px;\n                        filter: grayscale(100%);\n\n                        &:hover {\n                            filter: none;\n                            cursor: pointer;\n                        }\n\n                        &.selected {\n                            filter: none;\n                        }\n                    }\n\n                    span {\n                        width: 75%;\n                        margin-top: 15px;\n                        font: normal normal normal 14px/17px $fourth-font;\n                        color: #434343;\n                    }\n                }\n            }\n        }\n\n        .fk-modal-buttons {\n            display: flex;\n            gap: 20px;\n            padding: 10px 140px 50px 140px;\n\n            button {\n                color: #FFFFFF;\n                padding: 15px 30px;\n\n                &:disabled {\n                    opacity: .7;\n                }\n            }\n\n            .fk-modal-button-normal {\n                background: $base-ui-color;\n            }\n\n            .fk-modal-button-danger {\n                background: $warning-ui-color;\n            }\n        }\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
